var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiploma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.9983C4.82497 17.9862 3.64706 17.8897 2.87868 17.1213C2 16.2426 2 14.8284 2 12L2 8C2 5.17157 2 3.75736 2.87868 2.87868C3.75736 2 5.17157 2 8 2L16 2C18.8284 2 20.2426 2 21.1213 2.87868C22 3.75736 22 5.17157 22 8V12C22 14.8284 22 16.2426 21.1213 17.1213C20.3915 17.8512 19.2921 17.9748 17.3197 17.9957L16.5 17.9983",
    stroke: "#1C274D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6L15 6",
    stroke: "#1C274D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.5H17",
    stroke: "#1C274D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8905 13.9454C11.5297 13.4007 12.4699 13.4007 13.1092 13.9454C13.3831 14.1789 13.7237 14.32 14.0824 14.3486C14.9197 14.4154 15.5845 15.0802 15.6513 15.9174C15.6799 16.2762 15.821 16.6168 16.0544 16.8907C16.5992 17.53 16.5992 18.4702 16.0544 19.1094C15.821 19.3833 15.6799 19.7239 15.6513 20.0827C15.5845 20.9199 14.9197 21.5847 14.0824 21.6515C13.7237 21.6802 13.3831 21.8212 13.1092 22.0547C12.4699 22.5994 11.5297 22.5994 10.8905 22.0547C10.6165 21.8212 10.276 21.6802 9.91719 21.6515C9.07997 21.5847 8.41515 20.9199 8.34834 20.0827C8.31971 19.7239 8.17863 19.3833 7.94519 19.1094C7.40043 18.4702 7.40043 17.53 7.94519 16.8907C8.17863 16.6168 8.31971 16.2762 8.34834 15.9174C8.41515 15.0802 9.07997 14.4154 9.91719 14.3486C10.276 14.32 10.6165 14.1789 10.8905 13.9454Z",
    stroke: "#1C274D",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.2L11.3571 19L13.5 17",
    stroke: "#1C274D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiploma);
export default __webpack_public_path__ + "static/media/diploma.eb14a3c547517bfeb8e1071a813e5a5f.svg";
export { ForwardRef as ReactComponent };